/*
Generated time: July 12, 2025 11:53
This file was created by the app developer. Feel free to contact the original developer with any questions. It was minified (compressed) by AVADA. AVADA do NOT own this script.
*/
document.addEventListener("DOMContentLoaded", () => {
  let t = document.querySelector(".megamenu-container"),
      a = document.querySelector("#burger_menu"),
      s = document.getElementById("black_overlay"),
      c = document.body;
  var e = document.querySelectorAll("[data-submenu-trigger]");

  function o(e) {
      e.classList.add("tw-opacity-0", "tw-translate-x-4"), e.classList.add("tw-hidden");
      e = parseInt(e.dataset.level);
      document.querySelectorAll(`[data-divider="${e}"]`).forEach((e) => {
          e.style.opacity = "0";
      });
  }
  function l(e) {
      [Number(e) + 1, Number(e) + 2].forEach((e) => {
          document.querySelectorAll(`.submenu-panel[data-level="${e}"]`).forEach(o),
              document.querySelectorAll(`[data-divider="${e}"]`).forEach((e) => {
                  e.style.opacity = "0";
              });
      });
  }
  function r(e) {
      [e, Number(e) + 1, Number(e) + 2].forEach((e) => {
          document.querySelectorAll(`[data-level="${e}"] [data-submenu-trigger]`).forEach((e) => {
              e.classList.remove("active");
              var t = e.querySelector("svg");
              t && (t.style.transform = "rotate(0deg)");
          });
      });
  }

  function closeAll() {
      if (!t || !t.classList.contains("show")) return;
      document.querySelectorAll(".submenu-panel").forEach(o);
      document.querySelectorAll(".menu-link-container-btn").forEach((e) => e.classList.remove("active"));
      r(1);
      t.classList.remove("show");
      a && a.classList.remove("active");
      s && s.classList.remove("active");
      c.style.overflow = "auto";
  }

  function closeDeepestLevel() {
      var panels = Array.from(document.querySelectorAll(".submenu-panel")).filter(
          (p) => !p.classList.contains("tw-hidden")
      );
      if (!panels.length) {
          closeAll();
          return;
      }
      var deepest = Math.max.apply(null, panels.map((p) => parseInt(p.dataset.level)));
      var deepestPanels = panels.filter((p) => parseInt(p.dataset.level) === deepest);
      deepestPanels.forEach((p) => {
          o(p);
          var key = p.dataset.submenuContent;
          var trigger = document.querySelector(`[data-submenu-trigger="${key}"]`);
          if (trigger) {
              trigger.classList.remove("active");
              var btn = trigger.closest(".menu-link-container-btn");
              btn && btn.classList.remove("active");
              var arrow = trigger.querySelector("svg");
              arrow && requestAnimationFrame(() => { arrow.style.transform = "rotate(0deg)"; });
          }
      });
  }

  a &&
      t &&
      a.addEventListener("click", () => {
          t.classList.toggle("show"),
              a.classList.toggle("active"),
              s &&
                  (t.classList.contains("show")
                      ? (s.classList.add("active"), (c.style.overflow = "hidden"))
                      : (s.classList.remove("active"), (c.style.overflow = "auto")));
      }),
      document.addEventListener("click", (e) => {
          if (!t || !t.classList.contains("show")) return;
          var inner = t.querySelector("[data-megamenu-inner]");
          var inside = (inner ? inner.contains(e.target) : false) || (a && a.contains(e.target));
          if (!inside) closeDeepestLevel();
      }),
      s &&
          s.addEventListener("click", () => { closeDeepestLevel(); }),
      e.forEach((c) => {
          c.addEventListener("click", (e) => {
              var t,
                  a = c.closest(".menu-level").dataset.level,
                  s = document.querySelector(`[data-submenu-content="${c.dataset.submenuTrigger}"]`);
              s &&
                  (e.preventDefault(),
                  (e = c.querySelector("svg")),
                  c.classList.contains("active")
                      ? (c.classList.remove("active"),
                        c.closest(".menu-link-container-btn").classList.remove("active"),
                        s && (o(s), l(a)),
                        r(a))
                      : (document.querySelectorAll(`[data-level="${a}"] .menu-link-container-btn`).forEach((e) => {
                            e.classList.remove("active");
                            e = e.querySelector("[data-submenu-trigger]");
                            e && e.classList.remove("active");
                        }),
                        document.querySelectorAll(`.submenu-panel[data-level="${a}"]`).forEach(o),
                        l(a),
                        r(a),
                        s &&
                            ((t = s).classList.remove("tw-hidden"),
                            requestAnimationFrame(() => {
                                t.classList.remove("tw-opacity-0", "-tw-translate-x-4");
                                var e = parseInt(t.dataset.level);
                                document.querySelectorAll(`[data-divider="${e}"]`).forEach((e) => {
                                    e.style.opacity = "1";
                                });
                            }),
                            c.classList.add("active"),
                            c.closest(".menu-link-container-btn").classList.add("active"),
                            e &&
                            requestAnimationFrame(() => {
                                e.style.transform = "rotate(-90deg)";
                            }))));
          });
      });
}),
  (function() {
      var initialized = false;
      var currentLevel = 1;
      var menuHistory = [];

      function initMobileMenu() {
          var container = document.getElementById("megamenu-mobile-container");
          if (!container || initialized) return;
          initialized = true;

          var closeBtn = document.getElementById("mobile_menu_close");
          var backBtn = container.querySelector("[data-mobile-back]");
          var titleEl = container.querySelector("[data-mobile-current-title]");
          var rootTitle = titleEl ? titleEl.textContent : "";

          function getLevelPanels() {
              return container.querySelectorAll("[data-level]");
          }

          function updateLevels() {
              // Expune nivelul curent in DOM: CSS ascunde actiunile din bara de sus
              // pe nivelurile 2-3, ca titlul categoriei sa aiba loc pe ecrane mici.
              var stateEl = container.querySelector("[data-mobile-menu-state]");
              if (stateEl) stateEl.dataset.currentLevel = currentLevel;
              getLevelPanels().forEach(function(panel) {
                  var level = parseInt(panel.dataset.level);
                  if (level === currentLevel) panel.style.transform = "translateX(0)";
                  else if (level < currentLevel) panel.style.transform = "translateX(-100%)";
                  else panel.style.transform = "translateX(100%)";
              });
              if (backBtn) {
                  if (currentLevel > 1) backBtn.classList.remove("tw-hidden");
                  else backBtn.classList.add("tw-hidden");
              }
          }

          function showPanel(level, key) {
              container.querySelectorAll('[data-mobile-panel="' + level + '"]').forEach(function(p) {
                  p.classList.add("tw-hidden");
                  p.classList.remove("tw-flex", "tw-flex-col");
              });
              if (key) {
                  var target = container.querySelector('[data-mobile-panel="' + level + '"][data-mobile-key="' + key + '"]');
                  if (target) {
                      target.classList.remove("tw-hidden");
                      target.classList.add("tw-flex", "tw-flex-col");
                  }
              }
          }

          function resetMobile() {
              currentLevel = 1;
              menuHistory = [];
              if (titleEl) titleEl.textContent = rootTitle;
              updateLevels();
              // Hide all sub-panels
              container.querySelectorAll("[data-mobile-panel]").forEach(function(p) {
                  p.classList.add("tw-hidden");
                  p.classList.remove("tw-flex", "tw-flex-col");
              });
              container.classList.add("tw-hidden");
              document.body.style.overflow = "auto";
          }

          container.addEventListener("click", function(e) {
              var navBtn = e.target.closest("[data-mobile-navigate]");
              if (navBtn) {
                  e.preventDefault();
                  var targetLevel = parseInt(navBtn.dataset.mobileNavigate);
                  var title = navBtn.dataset.mobileTitle || navBtn.querySelector("span").textContent.trim();
                  var key = navBtn.dataset.mobileTarget;
                  menuHistory.push({ level: currentLevel, title: titleEl ? titleEl.textContent : rootTitle });
                  currentLevel = targetLevel;
                  if (titleEl) titleEl.textContent = title;
                  showPanel(targetLevel, key);
                  updateLevels();
                  return;
              }
          });

          if (backBtn) {
              backBtn.addEventListener("click", function() {
                  var prev = menuHistory.pop();
                  if (prev) {
                      currentLevel = prev.level;
                      if (titleEl) titleEl.textContent = prev.title;
                  } else {
                      currentLevel = 1;
                      if (titleEl) titleEl.textContent = rootTitle;
                  }
                  updateLevels();
              });
          }

          if (closeBtn) {
              closeBtn.addEventListener("click", function() { resetMobile(); });
          }
      }

      // Try on DOMContentLoaded
      document.addEventListener("DOMContentLoaded", initMobileMenu);
      // Also try immediately in case DOM is already ready
      if (document.readyState !== "loading") initMobileMenu();
      // Fallback: observe DOM for the container appearing later
      var obs = new MutationObserver(function() {
          if (document.getElementById("megamenu-mobile-container")) {
              initMobileMenu();
              obs.disconnect();
          }
      });
      obs.observe(document.body || document.documentElement, { childList: true, subtree: true });
  })();
